<form (ngSubmit)="search()" style="width: 100%">
  <div class="flex flex-wrap card form-group">
    <div class="flex-grow">
      <span class="md-inputfield filterItem">
        <input name="regNo" type="text" pInputText [(ngModel)]="filterVal.filters.regNo.value" />
        <label>Reg.No.</label>
      </span>
    </div>
    <div class="flex-grow">
      <span class="md-inputfield filterItem">
        <input name="from" type="text" pInputText [(ngModel)]="filterVal.filters.from.value" />
        <label>From Location</label>
      </span>
    </div>

    <div class="flex-grow">
      <span class="md-inputfield filterItem">
        <input name="to" type="text" pInputText [(ngModel)]="filterVal.filters.to.value" />
        <label>To Location</label>
      </span>
    </div>

    <div class="flex-grow" *ngIf="inboxType == inboxType_Closed">
      <span class="md-inputfield filterItem">
        <p-calendar
          [(ngModel)]="filterVal.filters.closedDateFrom.value"
          name="fromDate"
          dateFormat="dd/mm/yy"
          appendTo="body"
        ></p-calendar>
        <label>From Date</label>
      </span>
    </div>

    <div class="flex-grow" *ngIf="inboxType == inboxType_Closed">
      <span class="md-inputfield filterItem">
        <p-calendar
          [(ngModel)]="filterVal.filters.closedDateTo.value"
          name="toDate"
          dateFormat="dd/mm/yy"
          appendTo="body"
        ></p-calendar>
        <label>To Date</label>
      </span>
    </div>

    <div class="flex-grow" *ngIf="inboxType == inboxType_Cancelled">
      <span class="md-inputfield filterItem">
        <p-calendar
          [(ngModel)]="filterVal.filters.cancelledDateFrom.value"
          name="fromDate"
          dateFormat="dd/mm/yy"
          appendTo="body"
        ></p-calendar>
        <label>From Date</label>
      </span>
    </div>

    <div class="flex-grow" *ngIf="inboxType == inboxType_Cancelled">
      <span class="md-inputfield filterItem">
        <p-calendar
          [(ngModel)]="filterVal.filters.cancelledDateTo.value"
          name="toDate"
          dateFormat="dd/mm/yy"
          appendTo="body"
        ></p-calendar>
        <label>To Date</label>
      </span>
    </div>

    <div class="flex-grow" *ngIf="inboxType == inboxType_Completed">
      <span class="md-inputfield filterItem">
        <p-calendar
          [(ngModel)]="filterVal.filters.completedDateFrom.value"
          name="fromDate"
          dateFormat="dd/mm/yy"
          appendTo="body"
        ></p-calendar>
        <label>From Date</label>
      </span>
    </div>

    <div class="flex-grow" *ngIf="inboxType == inboxType_Completed">
      <span class="md-inputfield filterItem">
        <p-calendar
          [(ngModel)]="filterVal.filters.completedDateTo.value"
          name="toDate"
          dateFormat="dd/mm/yy"
          appendTo="body"
        ></p-calendar>
        <label>To Date</label>
      </span>
    </div>

    <div class="flex-grow">
      <p-dropdown
        name="taskTypes"
        [options]="taskTypes"
        [(ngModel)]="filterVal.filters.taskType.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
      ></p-dropdown>
    </div>

    <div class="flex-shrink">
      <button pButton type="submit" label="Search"></button>
      <button pButton type="button" label="Clear" (click)="clearFilter(dataTable)"></button>
    </div>
  </div>
</form>

<div [ngClass]="loading ? 'hideGrid' : 'showGrid'">
  <p-table
    #dataTable
    selectionMode="single"
    [sortField]="filterVal.sortField"
    [sortOrder]="filterVal.sortOrder"
    [value]="page.items"
    [rows]="filterVal.rows"
    [responsive]="true"
    [paginator]="true"
    rowHover="true"
    [first]="filterVal.first"
    [lazy]="true"
    [rowsPerPageOptions]="[10, 20, 50]"
    [pageLinks]="8"
    [totalRecords]="page.total"
    (onLazyLoad)="onGridLazyLoad($event)"
    resizableColumns="true"
    (onRowSelect)="onRowSelect($event)"
    [(selection)]="selectedJob"
    [hidden]="!isLoaded"
    styleClass="inbox-data-table dataTable"
  >
    <ng-template pTemplate="header">
      <tr>
        <th
          pResizableColumn
          pSortableColumn="scheduledDate"
          *ngIf="
            inboxType == inboxType_Waiting ||
            inboxType == inboxType_Unallocated ||
            inboxType == inboxType_GlobalFilter
          "
        >
          Scheduled Date
        </th>
        <th pResizableColumn pSortableColumn="vehicleRegNumber">Reg. No</th>
        <th pResizableColumn pSortableColumn="from">From</th>
        <th pResizableColumn pSortableColumn="to">To</th>
        <th
          pResizableColumn
          pSortableColumn="latestPickupDate"
          *ngIf="inboxType != inboxType_Closed"
        >
          Latest Pickup
        </th>
        <th
          pResizableColumn
          pSortableColumn="latestDropOffDate"
          *ngIf="inboxType != inboxType_Closed"
        >
          Latest Dropoff
        </th>
        <th pResizableColumn pSortableColumn="movementType" *ngIf="inboxType != inboxType_Closed">
          Movement Type
        </th>
        <th pResizableColumn pSortableColumn="vehiclesNum" *ngIf="inboxType != inboxType_Closed">
          Vehicles
        </th>
        <th
          pResizableColumn
          pSortableColumn="lastTaskCompleted"
          *ngIf="inboxType == inboxType_Closed"
        >
          CompletedDate
        </th>
        <th
          pResizableColumn
          pSortableColumn="journeyPrice"
          *ngIf="inboxType == inboxType_Closed && !hasCustomerPriceRole && !hasCustomerBookingRole"
        >
          Journey
        </th>
        <th
          pResizableColumn
          pSortableColumn="total"
          *ngIf="
            (inboxType == inboxType_Closed || inboxType == inboxType_Cancelled) &&
            !hasCustomerPriceRole &&
            !hasCustomerBookingRole
          "
        >
          Total
        </th>
        <th pResizableColumn *ngIf="inboxType == inboxType_GlobalFilter">Inbox</th>
        <th
          pResizableColumn
          pSortableColumn="orderLastUpdated"
          *ngIf="inboxType == inboxType_Cancelled"
        >
          Cancel Date
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr (dblclick)="jobScreen(item)" [pSelectableRow]="item" class="no-wrap-cells">
        <td
          *ngIf="
            inboxType == inboxType_Waiting ||
            inboxType == inboxType_Unallocated ||
            inboxType == inboxType_GlobalFilter
          "
        >
          <div title="{{ item.scheduledDate | datex : 'ddd DD MMM \'YY' }}">
            {{ item.scheduledDate | datex : "ddd DD MMM 'YY" }}
          </div>
        </td>
        <td>{{ vehicleCountPostfix(item, item.vehicleRegNumber) }}</td>
        <td>
          <div title="{{ tasksCountPostfix(item, inboxjobsService.addressStr(item.from)) }}">
            {{ tasksCountPostfix(item, inboxjobsService.addressStr(item.from)) }}
          </div>
        </td>
        <td>
          <div title="{{ tasksCountPostfix(item, inboxjobsService.addressStr(item.to)) }}">
            {{ tasksCountPostfix(item, inboxjobsService.addressStr(item.to)) }}
          </div>
        </td>
        <td *ngIf="inboxType != inboxType_Closed">
          <div
            title="Earliest: {{
              tasksCountPostfix(item, item.earliestPickupDate | datex : 'ddd DD MMM \'YY HH:mm')
            }}"
          >
            {{ tasksCountPostfix(item, item.latestPickupDate | datex : "ddd DD MMM 'YY HH:mm") }}
          </div>
        </td>
        <td *ngIf="inboxType != inboxType_Closed">
          <div
            title="Earliest: {{
              tasksCountPostfix(item, item.earliestDropOffDate | datex : 'ddd DD MMM \'YY HH:mm')
            }}"
          >
            {{ tasksCountPostfix(item, item.latestDropOffDate | datex : "ddd DD MMM 'YY HH:mm") }}
          </div>
        </td>
        <td *ngIf="inboxType != inboxType_Closed">
          <div title="{{ item.movementType }}">{{ item.movementType }}</div>
        </td>
        <td *ngIf="inboxType != inboxType_Closed" style="text-align: center">
          {{ item.vehiclesNum }}
        </td>
        <td *ngIf="inboxType == inboxType_Closed">
          <div title="{{ item.lastTaskCompleted | datex : 'ddd DD MMM \'YY HH:mm' }}">
            {{ tasksCountPostfix(item, item.lastTaskCompleted | datex : "ddd DD MMM 'YY HH:mm") }}
          </div>
        </td>
        <td
          *ngIf="inboxType == inboxType_Closed && !hasCustomerPriceRole && !hasCustomerBookingRole"
        >
          {{ item.journeyPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}
        </td>
        <td
          *ngIf="
            (inboxType == inboxType_Closed || inboxType == inboxType_Cancelled) &&
            !hasCustomerPriceRole &&
            !hasCustomerBookingRole
          "
        >
          {{ item.total | currency : 'GBP' : 'symbol' : '1.2-2' }}
        </td>
        <td *ngIf="inboxType == inboxType_GlobalFilter">{{ item.inboxTabName }}</td>
        <td *ngIf="inboxType == inboxType_Cancelled">
          <div title="{{ item.orderLastUpdated | datex : 'ddd DD MMM \'YY HH:mm' }}">
            {{ item.orderLastUpdated | datex : "ddd DD MMM 'YY HH:mm" }}
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- TABLE DEPRECATED
<p-dataTabl #dataTable selectionMode="single" [sortField]="filterVal.sortField" [sortOrder]="filterVal.sortOrder" [value]="page.items" [rows]="filterVal.rows" [responsive]="true"
           [paginator]="true" rowHover="true" [first]="filterVal.first"
           [lazy]="true" [rowsPerPageOptions]="[10,20,50]" [pageLinks]="8" [totalRecords]="page.total"
           (onLazyLoad)="onGridLazyLoad($event)" resizableColumns="true" (onRowSelect)="onRowSelect($event)"
           (onRowDblclick)="jobScreen(selectedJob)"
           [(selection)]="selectedJob"
           [hidden]="!isLoaded" styleClass="inbox-data-table dataTable">
  <p-column *ngIf="inboxType == inboxType_Waiting || inboxType == inboxType_Unallocated || inboxType == inboxType_GlobalFilter" field="scheduledDate"
            header="Scheduled Date" [sortable]="tru" [editable]="false" [style]="{'width': '11%'}">
      <ng-template let-item="rowData" pTemplate="body">
          <div title="{{item.scheduledDate | datex:'ddd DD MMM \'YY'}}">{{item.scheduledDate | datex:'ddd DD MMM \'YY'}}</div>
      </ng-template>
  </p-column>
  <p-column field="vehicleRegNumber" header="Reg. No." [sortable]="tru" [editable]="false" [style]="{'width': '8%'}">
      <ng-template let-item="rowData" pTemplate="body">
          <div title="{{vehicleCountPostfix(item, item.vehicleRegNumberDetails )}}">{{vehicleCountPostfix(item, item.vehicleRegNumber)}}</div>
      </ng-template>
  </p-column>
  <p-column field="pickup" header="From" [sortable]="tru" [editable]="false" [style]="{'width': '22%'}">
      <ng-template pTemplate="body" let-item="rowData">
          <div title="{{tasksCountPostfix(item, inboxjobsService.addressStr(item.from))}}">{{tasksCountPostfix(item, inboxjobsService.addressStr(item.from))}}</div>
      </ng-template>
  </p-column>
  <p-column header="To" field="dropoff" [sortable]="tru" [editable]="false" [style]="{'width': '22%'}">
      <ng-template pTemplate="body" let-item="rowData">
          <div title="{{tasksCountPostfix(item, inboxjobsService.addressStr(item.to))}}">{{tasksCountPostfix(item, inboxjobsService.addressStr(item.to))}}</div>
      </ng-template>
  </p-column>
  <p-column *ngIf="inboxType!=inboxType_Closed" field="pickupLatest" header="Latest Pick-up" [sortable]="tru"
            [editable]="false" [style]="{'width': '10%'}">
      <ng-template pTemplate="body" let-item="rowData">
          <div title="Earliest: {{tasksCountPostfix(item, item.earliestPickupDate | datex:'ddd DD MMM \'YY HH:mm')}}">{{tasksCountPostfix(item, item.latestPickupDate | datex:'ddd DD MMM \'YY HH:mm')}}</div>
      </ng-template>
  </p-column>
  <p-column *ngIf="inboxType!=inboxType_Closed" field="dropoffLatest" header="Latest Drop-Off" [sortable]="tru"
            [editable]="false" [style]="{'width': '10%'}">
      <ng-template pTemplate="body" let-item="rowData">
          <div title="Earliest: {{tasksCountPostfix(item, item.earliestDropOffDate | datex:'ddd DD MMM \'YY HH:mm')}}">{{tasksCountPostfix(item, item.latestDropOffDate | datex:'ddd DD MMM \'YY HH:mm')}}</div>
      </ng-template>
  </p-column>
  <p-column *ngIf="inboxType!=inboxType_Closed" field="movementType" header="Movement Type" [sortable]="tru"
            [editable]="false" [style]="{'width': '10%'}" styleClass="align-center">
      <ng-template pTemplate="body" let-item="rowData">
          <div title="{{item.movementTypeDetails}}">{{item.movementType}}</div>
      </ng-template>
  </p-column>
  <p-column *ngIf="inboxType!=inboxType_Closed" field="vehiclesNum" header="Vehicles" [sortable]="false"
            [style]="{'width': '6%'}" [editable]="false" styleClass="align-center"></p-column>

  <p-column *ngIf="inboxType==inboxType_Closed" field="lastTaskCompleted" header="Completed Date" [sortable]="tru" [editable]="false"
            [style]="{'width': '10%'}" styleClass="align-center">
      <ng-template pTemplate="body" let-item="rowData">
          <div title="{{item.lastTaskCompleted | datex:'ddd DD MMM \'YY HH:mm'}}">{{tasksCountPostfix(item, item.lastTaskCompleted | datex:'ddd DD MMM \'YY HH:mm')}}</div>
      </ng-template>
  </p-column>
  <p-column *ngIf="inboxType==inboxType_Closed" field="journeyPrice" header="Journey"
            [style]="{'width': '10%'}" styleClass="align-center"
            [sortable]="false" [editable]="false">
      <ng-template let-item="rowData" pTemplate="body">{{ item.journeyPrice | currency:'GBP':'symbol':'1.2-2' }}</ng-template>
  </p-column>
  <p-column *ngIf="inboxType==inboxType_Closed || inboxType==inboxType_Cancelled" field="total" header="Total"
            [style]="{'width': '10%'}"
            [sortable]="false" [editable]="false" styleClass="align-center">
      <ng-template let-item="rowData" pTemplate="body">{{ item.total | currency:'GBP':'symbol':'1.2-2' }}</ng-template>
  </p-column>
  <p-column *ngIf="inboxType == inboxType_GlobalFilter" field="inboxTabName" styleClass="align-center supplier-price"
            header="Inbox" [sortable]="false" [editable]="false"
            [style]="{'width': '8%'}">
      <ng-template let-item="rowData" pTemplate="body">
          <div>{{item.inboxTabName}}</div>
      </ng-template>
  </p-column>
  <p-column *ngIf="inboxType == inboxType_Cancelled" field="orderLastUpdated" styleClass="align-center supplier-price"
            header="Cancelled Date" [sortable]="tru" [editable]="false"
            [style]="{'width': '12%'}">
      <ng-template let-item="rowData" pTemplate="body">
          <div title="{{item.orderLastUpdated | datex:'ddd DD MMM \'YY HH:mm'}}">{{item.orderLastUpdated | datex:'ddd DD MMM \'YY HH:mm'}}</div>
      </ng-template>
  </p-column>
</p-dataTable>

--></div>

<div class="footerPanel ui-grid-row">
  <button
    *ngIf="inboxType == inboxType_Unallocated || inboxType == inboxType_Waiting"
    class="btn-to-right"
    type="button"
    (click)="editOrder(selectedJob)"
    icon="fa fa-list"
    label="Edit Order"
    pButton
    [disabled]="!selectedJob"
  ></button>

  <button
    *ngIf="
      inboxType == inboxType_Unallocated ||
      inboxType == inboxType_Waiting ||
      inboxType == inboxType_Completed ||
      inboxType_Closed
    "
    class="btn-to-right"
    type="button"
    (click)="jobScreen(selectedJob)"
    icon="fa fa-cloud-download"
    label="Order Details"
    pButton
    [disabled]="!selectedJob"
  ></button>

  <button
    *ngIf="
      (inboxType == inboxType_Closed || inboxType == inboxType_Cancelled) &&
      !hasCustomerBookingRole &&
      !hasCustomerPriceRole
    "
    class="btn-to-right"
    type="button"
    (click)="showPriceDetails()"
    icon="fa fa-info"
    label="Price Details"
    pButton
    [disabled]="!selectedJob"
  ></button>
</div>

<div *ngIf="loading" class="loading-class"><i class="fa fa-spinner fa-spin"></i> Loading...</div>
